import { Layout, Space } from "antd";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { closeAuthSocket, initAuthSocket } from "../../api/webSocketRx";
import { useAuthLayoutContext } from "../../context/AuthLayoutContext";
import SmallInComingCall from "../../pages/conversation/calling/SmallInComingCall";
import { SmallRecord } from "../../pages/record/SmallRecord";
import { useSideBarStore } from "../../store/SideBarStore";
import ConnectionToast from "../modal/ConnectionToast";
import { SideBar } from "../sideBar/SideBar";
import "./style.scss";

const AuthLayout = ({ children }) => {
  const { verified, rejectCall, call, setCall } = useAuthLayoutContext();
  const { isRecord } = useSideBarStore((state) => state);

  // useEffect(() => {
  //   const handleOnline = () => {
  //     console.log("Network restored, attempting to reconnect...");
  //     initAuthSocket();
  //   };
  //
  //   window.addEventListener("online", handleOnline);
  //
  //   return () => {
  //     window.removeEventListener("online", handleOnline);
  //     closeAuthSocket();
  //   };
  // }, []);

  return (
    <Space className="space-app" direction="vertical" size={[0, 48]}>
      {verified && (
        <Layout className="layout-app flex flex-row">
          <SideBar />
          <Layout.Content className="flex-1 min-w-0 overflow-hidden">
            <Outlet />
          </Layout.Content>

          <ConnectionToast />

          {!!call && <SmallInComingCall />}
          {isRecord && (
            <SmallRecord
              open={isRecord}
              // onCancel={() => {
              //   setIsVideo(false);
              // }}
              // onClose={rejectCall}
            />
          )}
        </Layout>
      )}
    </Space>
  );
};

export default AuthLayout;
